import {
  ARIAL_FONT,
  LIBERATION_SANS_FONT,
  LIBERATION_SERIF_FONT,
  LIBERATION_MONO_FONT
} from 'pxc-editor-material-svg-rendering/constants';
import { getCurrentEnvironment } from '@/helpers';
import { APP_ENVIRONMENT } from '@/constants';

export default function calculateFontSizeCoef() {
  const currentEnvironment = getCurrentEnvironment();

  switch (currentEnvironment) {
    case APP_ENVIRONMENT.WEB_COMPONENT: {
      return {
        [ARIAL_FONT]: 1.4292,
        [LIBERATION_SANS_FONT]: 1.4292,
        [LIBERATION_SERIF_FONT]: 1.4292,
        [LIBERATION_MONO_FONT]: 1.4292,
      }
    }
    default: {
      return {
        [ARIAL_FONT]: 1,
        [LIBERATION_SANS_FONT]: 1,
        [LIBERATION_SERIF_FONT]: 1,
        [LIBERATION_MONO_FONT]: 1,
      };
    }
  }
}
